import signupImg from "../assets/Images/signup.png"
import Template from "../components/core/Auth/Template"

function Signup() {
  return (
    <Template
      title="Join the Thousands Dog Parents to train you dog with Thapar Dog School"
      description1="Train your dog for today, tomorrow, and beyond."
      description2="Make you Dog Obedient."
      image={signupImg}
      formType="signup"
    />
  )
}

export default Signup
